import * as Yup from 'yup';

import dayjs from 'dayjs';

import { createLocale } from 'locales';

import { SUPPORTED_DOC_TYPES } from 'constants/signup-flow-constants';

const localize = createLocale('freelancerAddCertificationDocumentPageLocales');

export default Yup.object().shape({
  dtype: Yup.number().required().typeError(localize('selectDocType')),
  file: Yup.mixed()
    .required(localize('fileRequired'))
    .test(
      'fileType',
      localize('wrongFileExtension'),
      (value) =>
        value !== null &&
        SUPPORTED_DOC_TYPES.includes(
          value.type as typeof SUPPORTED_DOC_TYPES[0],
        ),
    ),
  isValidationDateRequired: Yup.string(),
  validUntil: Yup.string()
    .when('isValidationDateRequired', {
      is: (isValidationDateRequired: string) =>
        isValidationDateRequired === 'true',
      then: Yup.string().required(localize('validUntilRequired')),
    })
    .test('validUntil', localize('dateInvalid'), (value) => {
      if (value !== null && value !== undefined)
        return value >= dayjs().format('YYYY-MM-DD').toString();
      return true;
    }),
});
